// Custom validator function for required fields
export const requiredValidator = (fieldData, value) => {
  if (!value) {
    return Promise.reject(
      new Error(
        `Please fill the ${fieldData.field
          .replace(/([A-Z])/g, " $1")
          .trim()
          .toLowerCase()} field! `
      )
    );
  }
  if (!value.length) {
    if (value && value.trim().length === 0) {
      return Promise.reject(
        new Error("Field must not be empty or contain only spaces")
      );
    }
  }
  if (fieldData.field === "clientName") {
    const regex = /^[^\s_]+$/;
    if (!regex.test(value)) {
      return Promise.reject(
        new Error("clientName must not contain spaces or underscores")
      );
    }
  }
  return Promise.resolve();
};
export const namingPolicy = (fieldData, value) => {
  if (!value) {
    return Promise.reject(
      new Error(
        `Please fill the  field! `
        // ${fieldData.field
        //   .replace(/([A-Z])/g, " $1")
        //   .trim()
        //   .toLowerCase()}
      )
    );
  }
  if (value) {
    const regex = /^[^\s_]+$/;
    if (!regex.test(value)) {
      return Promise.reject(
        new Error("Instance name must not contain spaces or underscores")
      );
    }
  }
  return Promise.resolve();
};
